<div class="dashboard-skeleton">
  <!-- Skeleton Tabs -->
  <div class="skeleton-tabs">
    <div class="skeleton-tablist">
      <div class="skeleton-tab skeleton-tab-active">
        <p-skeleton width="5rem" height="1.25rem" />
        <p-skeleton
          width="2.5rem"
          height="1.25rem"
          borderRadius="12px"
          class="badge-skeleton"
        />
      </div>
      <div class="skeleton-tab">
        <p-skeleton width="6rem" height="1.25rem" />
      </div>
      <div class="skeleton-tab">
        <p-skeleton width="9rem" height="1.25rem" />
      </div>
      <div class="skeleton-tab">
        <p-skeleton width="4rem" height="1.25rem" />
      </div>
    </div>
  </div>

  <!-- Skeleton Content -->
  <div class="skeleton-content">
    <!-- Skeleton Toggle Button -->
    <div class="skeleton-toggle">
      <p-skeleton width="2.5rem" height="2.5rem" borderRadius="6px" />
    </div>

    <!-- Skeleton Sidebar (Filters) -->
    <div class="skeleton-sidebar">
      <div class="skeleton-sidebar-header">
        <p-skeleton
          width="1.5rem"
          height="1.5rem"
          borderRadius="4px"
          class="mb-1"
        />
        <p-skeleton width="4rem" height="1.25rem" />
      </div>

      <!-- Date Range Section -->
      <div class="skeleton-filter-section">
        <p-skeleton width="7rem" height="1rem" class="mb-2" />
        <div class="skeleton-filter-label">
          <p-skeleton width="9rem" height="0.75rem" class="mb-1" />
        </div>
        <p-skeleton
          width="100%"
          height="2.75rem"
          borderRadius="6px"
          class="mb-3"
        />
        <div class="skeleton-filter-label">
          <p-skeleton width="12rem" height="0.75rem" class="mb-1" />
        </div>
        <p-skeleton width="100%" height="2.75rem" borderRadius="6px" />
      </div>

      <!-- Currency Section -->
      <div class="skeleton-filter-section">
        <p-skeleton width="5rem" height="1rem" class="mb-2" />
        <div class="skeleton-filter-label">
          <p-skeleton width="5rem" height="0.75rem" class="mb-1" />
        </div>
        <p-skeleton width="100%" height="2.75rem" borderRadius="6px" />
      </div>
    </div>

    <!-- Skeleton Main Content -->
    <div class="skeleton-main">
      <!-- Skeleton Header with Title and Actions -->
      <div class="skeleton-header-section">
        <div class="skeleton-title-group">
          <p-skeleton width="28rem" height="1.75rem" class="mb-2" />
          <p-skeleton width="35rem" height="1rem" />
        </div>
        <div class="skeleton-actions">
          <p-skeleton width="2.5rem" height="2.5rem" borderRadius="6px" />
          <p-skeleton width="2.5rem" height="2.5rem" borderRadius="6px" />
        </div>
      </div>

      <!-- Skeleton Revenue Cards -->
      <div class="skeleton-cards">
        <!-- All Revenue Card (Blue) -->
        <div class="skeleton-card skeleton-card-blue">
          <div class="skeleton-card-border"></div>
          <div class="skeleton-card-content">
            <div class="skeleton-card-title">
              <p-skeleton width="7rem" height="0.875rem" />
            </div>
            <div class="skeleton-card-amount">
              <p-skeleton width="10rem" height="3rem" class="mb-2" />
            </div>
            <div class="skeleton-card-change">
              <p-skeleton width="5rem" height="1rem" class="mb-3" />
            </div>
            <div class="skeleton-card-metrics">
              <div class="skeleton-metric-item">
                <p-skeleton width="3.5rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="2.5rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
              <div class="skeleton-metric-item">
                <p-skeleton width="2rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="3rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Subscription Card (Green) -->
        <div class="skeleton-card skeleton-card-green">
          <div class="skeleton-card-border"></div>
          <div class="skeleton-card-content">
            <div class="skeleton-card-title">
              <p-skeleton width="8rem" height="0.875rem" />
            </div>
            <div class="skeleton-card-amount">
              <p-skeleton width="10rem" height="3rem" class="mb-2" />
            </div>
            <div class="skeleton-card-change">
              <p-skeleton width="5rem" height="1rem" class="mb-3" />
            </div>
            <div class="skeleton-card-metrics">
              <div class="skeleton-metric-item">
                <p-skeleton width="3.5rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="2.5rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
              <div class="skeleton-metric-item">
                <p-skeleton width="2rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="3rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Non-Subscription Card (Purple) -->
        <div class="skeleton-card skeleton-card-purple">
          <div class="skeleton-card-border"></div>
          <div class="skeleton-card-content">
            <div class="skeleton-card-title">
              <p-skeleton width="11rem" height="0.875rem" />
            </div>
            <div class="skeleton-card-amount">
              <p-skeleton width="10rem" height="3rem" class="mb-2" />
            </div>
            <div class="skeleton-card-change">
              <p-skeleton width="5rem" height="1rem" class="mb-3" />
            </div>
            <div class="skeleton-card-metrics">
              <div class="skeleton-metric-item">
                <p-skeleton width="3.5rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="2.5rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
              <div class="skeleton-metric-item">
                <p-skeleton width="2rem" height="0.75rem" class="mb-1" />
                <div class="skeleton-metric-value">
                  <p-skeleton width="3rem" height="1.25rem" />
                  <p-skeleton width="3rem" height="0.875rem" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Coming Soon Message -->
      <div class="skeleton-footer">
        <p-skeleton width="20rem" height="1rem" />
      </div>
    </div>
  </div>
</div>
